
export const EDITOR_PREVIEW_FILE = `assets/img/editor-coment-file.svg`;
export const EDITOR_LOADING_FILE = `assets/img/editor-coment-image.gif`;
export const EDITOR_SYNC_FILE = `assets/img/editor-sync-file.svg`;
export const IMAGE_MIN_WIDTH = 100;
